module.exports = __webpack_public_path__ + "static/media/imageChoice.f5bcd61a.svg";